import React from "react"
import logo from '../../../images/logo_RT132.png';

import InitiativesCard from "../Initiatives/InitiativesCard"
import Title from "../../../components/global/Title/Title"

import Slider from "../../../components/global/Slider/Slider"

export default class Initiatives extends React.Component {
  render() {

    const { data } = this.props

    return(
      <section className="initiatives dotted h-auto -pt-0 relative overflow-hidden">
        <div className="animation-float animation-ease animation-infinite animation-fill-forwards animation-10s animation-delay-2s z-10 h-3 w-3 absolute bottom-2/12 right-2/12 bg-orange rounded-full"></div>
        <div className="animation-float animation-ease animation-infinite animation-fill-forwards animation-3s z-10 h-10 w-10 absolute bottom-1/12 right-1/4 border-4 border-orange rounded-full"></div>
        <div className="max-w-screen-xl mx-auto px-4 sm:px-6 md:flex md:flex-wrap lg:px-8 relative z-10">
          <div className="w-full mb-12">
            <Title level="2" className="underlined">Initiatieven</Title>
          </div>
          <div className="w-full">
            <div className="flex -mx-4">
              <Slider
                options={{
                  autoPlay: false,
                  pauseAutoPlayOnHover: true,
                  imagesLoaded: true,
                  cellAlign: 'left',
                  pageDots: false
                }}
                >
                {data && data.map(prop => {
                  return (
                    <div key={prop.id} className="w-full inline-block md:w-6/12 lg:w-5/12 px-4">
                      <InitiativesCard id={prop.id} title={prop.title.rendered} label={prop.date} link={`/${prop.type}/${prop.slug}/`} imageSrc={prop.better_featured_image ? prop.better_featured_image.source_url : logo}/>
                    </div>
                  )
                })}
              </Slider>
            </div>
          </div>
        </div>
        <div className="absolute bottom-0 left-0 top-1/2 right-0 height-1/2 bg-lightorange"></div>
      </section>
    )
  }
}
